/**
 * Get the customerNumber of the main account. This is necessary when f.ex.
 * fetching fictive portfolios or products, which are always on the main
 * account, not the selected account when you have a power of attourney
 * situation.
 */
export function getUserId(user) {
  if (!user) {
    throw new Error('User.getUserId: user was ' + user);
  }

  return getCustomerData(user).get('customerNumber');
}

export function getCustomerData(user) {
  return user.get('customerData') || user.get('takeover');
}
